import React, { createContext, useContext } from 'react';
import { Box, ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import styled from 'styled-components';

// Inside a panel a ChartCard draws as a column, without a border of its own
export const ChartPanelContext = createContext(false);
export const useInPanel = () => useContext(ChartPanelContext);

// Three columns once each gets about 340px, two before that, one on a phone. A slight resize
// moves one step, not straight from three columns to a long stack.
const TWO = '620px';
const THREE = '1060px';

const Wrap = styled.div`container-type: inline-size;`;

// One cell per card that renders: a card that returns null leaves no gap. The 1px gap shows the
// line color through, so the dividers follow whichever way the cards wrap.
const Columns = styled.div`
    display: grid;
    gap: 1px;
    background: ${(props) => props.$line};
    & > * { background: ${(props) => props.$bg}; }

    @container (min-width: ${TWO}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        /* An odd one out takes the whole row rather than leaving an empty cell beside it */
        & > :last-child:nth-child(odd) { grid-column: 1 / -1; }
    }
    @container (min-width: ${THREE}) {
        grid-template-columns: none;
        grid-auto-flow: column;
        grid-auto-columns: minmax(0, 1fr);
        & > :last-child:nth-child(odd) { grid-column: auto; }
    }
`;

// No frame at all when every card in it renders nothing, rather than an empty bordered box
const Frame = styled(Box)`
    &:has(> div > div:empty) { display: none; }
`;

// Several related cards in one frame, so they line up however long each one is
const ChartPanel = ({ children }) => {
    const theme = useContext(ThemeContext);
    return (
        <Frame round="xsmall" border elevation="medium" background="background">
            <Wrap>
                <Columns $line={normalizeColor('border-weak', theme)} $bg={normalizeColor('background', theme)}>
                    <ChartPanelContext.Provider value>{children}</ChartPanelContext.Provider>
                </Columns>
            </Wrap>
        </Frame>
    );
};

export default ChartPanel;
